import { useNavigate } from "react-router-dom";
import { getFromLocalStorage } from "../../utils/storageUtil";
import { useEffect } from "react";


const VerifyEmailGuard = ({ children }) => {

    const navigate = useNavigate();
    const isEmailVerified = getFromLocalStorage('isEmailVerified');

    useEffect(() => {
        if (!isEmailVerified) {
            navigate('/auth/forgot-password');
        }
    }, [])

    if (isEmailVerified) {
        return <>{children}</>;
    } else {
        navigate('/auth/forgot-password');
        return null;
    }
}

export default VerifyEmailGuard;